import en from './lang_en.json';
import sv from './lang_sv.json';

export default { en, sv } as { [key: string]: Record<string, string> };
